import fb from '@/services/firebase'
import { Timestamp, getDocs, getDoc, doc, updateDoc } from 'firebase/firestore'
import useDateFilter from '@/assets/lib/date_filter'
import useFirebaseQuery from '@/assets/lib/firebase_query'

export const namespaced = true

export const state = {
  vendors: [],
  vendor_loading: false
}

export const mutations = {
  SET_VENDORS(state, payload) {
    state.vendors = payload
  },
  SET_VENDOR_LOADING(state, payload) {
    state.vendor_loading = payload
  },
  UPDATE_VENDORS(state, payload) {
    state.vendors.forEach(item => {
      const businessFound = item.businesses.findIndex(eachBusiness => eachBusiness.business_id === payload.business_id)
      if (businessFound !== -1) {
        item.businesses[businessFound].business_name = payload.business_name
        item.businesses[businessFound].owner_id = payload.owner_id
        item.new_item = true
      }
    })
  }
}

export const actions = {
  async allSuppliers({ commit, dispatch }, payload) {
    const date_filter = useDateFilter().dateFilter(payload)
    const start_date = Timestamp.fromDate(new Date(date_filter.start_date))
    const end_date = Timestamp.fromDate(new Date(date_filter.end_date))
    const num_of_days = Timestamp.fromDate(new Date(date_filter.num_of_days))

    let suppliers
    if (payload.period !== 'Between Dates') {
      suppliers = useFirebaseQuery().multiSimpleQuery(
        'dashboard_summary',
        'vendors',
        'breakdown',
        'updated_at',
        num_of_days
      )
    } else {
      suppliers = useFirebaseQuery().multiComplexQuery(
        'dashboard_summary',
        'vendors',
        'breakdown',
        'updated_at',
        start_date,
        end_date
      )
    }

    // const sales = query(
    //   collection(fb.db, 'dashboard_summary', 'vendors', 'breakdown'),
    //   where('updated_at', '>=', new_date)
    // )
    const querySnapshot = await getDocs(suppliers)
    const container = []
    if (!querySnapshot.empty) {
      querySnapshot.forEach(snapDoc => {
        const details = snapDoc.data()
        details.id = snapDoc.id
        container.push(details)
        for (let index = 0; index < snapDoc.data().businesses.length; index++) {
          const business = snapDoc.data().businesses[index]
          if (business.business_name === undefined) {
            dispatch('getBusinessDetails', {
              business_id: business.business_id,
              breakdown_id: snapDoc.id,
              business_index: index
            })
          }
        }
      })
      commit('SET_VENDORS', container)
    } else {
      commit('SET_VENDORS', container)
    }
  },
  async updateDashboardSummary({ state }) {
    state.vendors.forEach(item => {
      if (item.new_item != undefined) {
        updateDoc(doc(fb.db, 'dashboard_summary', 'vendors', 'breakdown', item.id), {
          businesses: item.businesses
        })
      }
    })
  },
  async getBusinessDetails({ commit }, payload) {
    const business_details = await getDoc(doc(fb.db, 'businesses', payload.business_id))
    commit('UPDATE_VENDORS', {
      business_id: payload.business_id,
      business_name: business_details.data().business_name,
      owner_id: business_details.data().owner_id
    })
  }
}
